export default "__VITE_ASSET__09lA8R8Z__"